import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField } from "helpers/row-logic-helper";

import { shouldShowField } from "../loanDetailEditUtil";

import {
  shouldShowGeneralSub,
  shouldShowMisc
} from "./section-loan-misc-row-logic";

const DEFAULT_WIDTH = 138;

export const rows = {
  generalSubSection: {
    isVisible: loan => shouldShowGeneralSub(loan),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        className: "subsection",
        width: DEFAULT_WIDTH,
        label: "General",
        Cell: tableSideColumnMapper,
        colSpan: 3
      }
    ]
  },

  misc: {
    isVisible: data => shouldShowMisc(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Misc. Reporting",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "covenants.financialReportingMisc"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.covenants.financialReportingMisc"
      }
    ]
  },

  deliveryContract: {
    isVisible: data => shouldShowField(data, "covenants.deliveryContact"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Delivery Contact",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "covenants.deliveryContact.fullName"),
        Cell: tableSideColumnMapper
      }
    ]
  }
};
